import React, { useState } from "react";
import Icon from "../../Layouts/Icons";
import ImageUploadItem from "./ImageUploadItem";
import Style from "./ImageUploadMinimized.module.scss";

const ImageUploadMinimized = ({
  setIsShowImageUpload,
  uploadReadyImages,
  uploadResponses,
  currentlyUploading,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const thumData =
    currentlyUploading &&
    uploadResponses?.total - uploadReadyImages?.length >
      uploadResponses?.uploaded &&
    uploadResponses?.total !== 0
      ? [
          currentlyUploading,
          ...uploadResponses?.uploadedImage?.reverse()?.slice(-5),
        ]
      : [...uploadResponses?.uploadedImage?.reverse()?.slice(-5)];
  return (
    <div
      className={`${Style.ImageUploadMinimized} ${
        isCollapsed && Style.ImageUploadMinimized__collapsed
      }`}
    >
      <div className={Style.ImageUploadMinimized__head}>
        <h5 className={Style.ImageUploadMinimized__title}>
          {uploadResponses?.uploadedImage[0]?.result?.code === 402 ? (
            <span className={Style.errorMsg}>
              {uploadResponses?.uploadedImage[0]?.result?.message}
            </span>
          ) : uploadResponses?.total - uploadReadyImages?.length > 0 &&
            uploadResponses?.uploaded ==
              uploadResponses?.total - uploadReadyImages?.length ? (
            `Uploaded ${
              uploadResponses?.total - uploadReadyImages?.length
            } Photos`
          ) : (
            `Uploading ${Math.abs(
              uploadResponses?.total -
                uploadReadyImages?.length -
                uploadResponses?.uploaded
            )} Photos`
          )}
        </h5>
        <div className={Style.ImageUploadMinimized__actions}>
          {uploadResponses?.uploadedImage[0]?.result?.code !== 402 && (
            <button
              className={Style.ImageUploadMinimized__collapseBtn}
              onClick={() =>
                isCollapsed ? setIsCollapsed(false) : setIsCollapsed(true)
              }
            >
              <Icon color={"#000"} size={12} icon={"dropdown-arrow-down"} />
            </button>
          )}

          <button
            className={Style.ImageUploadMinimized__close}
            onClick={() => setIsShowImageUpload(false)}
          >
            <Icon color={"#000"} size={12} icon={"icon-close"} />
          </button>
        </div>
      </div>
      <div className={Style.ImageUploadMinimized__body}>
        <ul className={Style.ImageUploadMinimized__list}>
          {thumData.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <ImageUploadItem image={item} index={index} />
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ImageUploadMinimized;
